import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/')({
  beforeLoad: ({ context }) => {
    const orgSlug = context.user.userOrgProfile?.org.slug
    if (!orgSlug) {
      throw redirect({ to: '/login' })
    }
    throw redirect({ to: '/$orgSlug', params: { orgSlug } })
  }
})
